import { PublicKey } from '@solana/web3.js'
import { Connection } from '@solana/web3.js'

import { ANCHOR_PROVIDER_URL } from '@src/configs/env'

console.log('ANCHOR_PROVIDER_URL', ANCHOR_PROVIDER_URL)

export const IRIS_API_URL = process.env.REACT_APP_IRIS_API_URL ?? 'https://iris-api-sandbox.circle.com'
export const SOLANA_SRC_DOMAIN_ID = 5
export const SOLANA_USDC_ADDRESS = new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v')

export const SOLANA_CONNECTION = new Connection(ANCHOR_PROVIDER_URL)
